import React from "react";
import { Formik } from "formik";
import { Form, InputGroup, Image } from "react-bootstrap";
import {
  FormControlSearch,
  LoaderWrapper,
  SliderPanel,
} from "../../../components";
import MappedPlanGroupSliderData from "./MappedPlanGroupSliderData";
import { useState } from "react";
import { getPlanGroupInfo } from "../../../services";
import { isEmpty } from "lodash";
import { useDeepEffect, useRequest } from "../../../abstracts";

const MappedPlanGroupSlider = (props) => {
  const { slideout, setSlideOut, planGroupId } = props;
  const [filteredValues, setFilteredValues] = useState([]);

  const { response: planData, loading } = useRequest({
    method: getPlanGroupInfo,
    payload: planGroupId,
    defaultResponse: [],
  });

  useDeepEffect(() => {
    if (!isEmpty(planData.planMappings))
      setFilteredValues(planData.planMappings);
  }, [planData]);

  const searchByPlanName = (value) => {
    if (value.length > 0) {
      const searchList = planData.planMappings.filter((f) =>
        f.name.toLowerCase().includes(value.toLowerCase())
      );
      return setFilteredValues(searchList);
    } else setFilteredValues(planData.planMappings);
  };
  const onClose = () => {
    setSlideOut(false);
  };

  const onFormSubmit = () => {};

  return (
    slideout && (
      <LoaderWrapper isLoading={loading}>
        <Formik
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            setValues,
            ...rest
          }) => {
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={rest.submitCount > 0}
              >
                <SliderPanel
                  isOpen={slideout}
                  size="30"
                  showCancelButton={false}
                  // showSave={true}
                  showCancel={true}
                  backdropClicked={onClose}
                  onClose={onClose}
                >
                  <div>
                    <p className="ft-14 mb-1">{planData?.name} mapped plans</p>
                    <p className="ft-14 grey-text">
                      {planData?.planMappings?.length} plans
                    </p>
                  </div>

                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>
                        <Image
                          src="/assets/icons/svg/search.svg"
                          width="14px"
                        />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControlSearch
                      type="search"
                      placeholder="Search plan name & Id"
                      onChange={(e) => {
                        searchByPlanName(e.target.value);
                      }}
                    />
                  </InputGroup>
                  <div>
                    {!isEmpty(planData) &&
                      filteredValues.map((item, index) => {
                        return <MappedPlanGroupSliderData item={item} />;
                      })}
                  </div>
                </SliderPanel>
              </Form>
            );
          }}
        </Formik>
      </LoaderWrapper>
    )
  );
};

export default MappedPlanGroupSlider;
